export default __webpack_public_path__ + "static/media/Me-documentation.da47d7e3.md";